/** Поддержка / разработка — та же ссылка, что в сайдбаре */
export const UNITIX_SUPPORT_URL = 'https://wa.me/99675573337';

export const SOURCES = [
  'Instagram',
  'Реклама',
  'Рекомендация',
  'Поликлиника',
  'Семья/Друзья',
  'Другое',
];

export const SEGMENTS = [
  { value: 'vip', label: 'VIP' },
  { value: 'regular', label: 'Активный' },
  { value: 'lost', label: 'Пропал' },
];
